'use client'

import { Fit, Layout, useRive } from '@rive-app/react-webgl2'

type HeightOption = 16 | 20 | 24 | 28 | 32 | 36 | 40 | 44 | 48 | 52 | 56 | 60 | 64 | 72 | 80 | 96

interface WorkflowPanelLoadingProps {
  height?: HeightOption
}

const heightClasses: Record<HeightOption, string> = {
  16: 'h-16',
  20: 'h-20',
  24: 'h-24',
  28: 'h-28',
  32: 'h-32',
  36: 'h-36',
  40: 'h-40',
  44: 'h-44',
  48: 'h-48',
  52: 'h-52',
  56: 'h-56',
  60: 'h-60',
  64: 'h-64',
  72: 'h-72',
  80: 'h-80',
  96: 'h-96',
}

const WorkflowPanelLoading = ({ height = 32 }: WorkflowPanelLoadingProps) => {
  const { RiveComponent } = useRive({
    src: '/animation/workflow_loading.riv',
    stateMachines: 'State Machine 1',
    autoplay: true,
    layout: new Layout({
      fit: Fit.Contain,
    }),
  })

  return (
    <div className={`flex ${heightClasses[height]} w-full items-center justify-center`}>
      <RiveComponent />
    </div>
  )
}

export default WorkflowPanelLoading
